import { round100 } from 'shared/utils/numbers/round.ts';

export const calculateVolume = (length: number, width: number, height: number): number => {
  const result = round100(length * width * height);
  return result <= 0.01 ? 0.01 : result;
};
